export default __webpack_public_path__ + "static/media/songwriting.cf40d154.jpg";